import { Instance, types } from 'mobx-state-tree';
import Common from '@store/common';
import GenericSpei from '@store/genericSpei';

const MonatoStore = types.compose(Common, types.model({}), GenericSpei);

export type IMonatoStore = Instance<typeof MonatoStore>;
export default MonatoStore;
